<!--nav1-->
<app-main-nav-bar></app-main-nav-bar>
<div class="main" data-request="1995">
  <div class="wrap">
    <div class="sub-request elem" style="display: block;">
      <div class="row">
        <div class="col col-12">
          <div class="head">
            <h2 style="text-align: center">اطلاعات درخواست بیمه
            </h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-12"
             *ngFor="let request of requestInfo; let last = last">
          <app-details-div
            [rawCount]="3"
            [icon]="icon"
            [array]="request.getViewArray()"
            [header]="request.getRequestID() + ''"
            [id]="request.getRequestID()"
            (takeAction)="takeAction()"
            [backUrl]="'/mobile/guest'"
            [backLabel]="'بازگشت'"
            [mainLabel]="buttonLabel"
            [translation]="translation"
          ></app-details-div>
        </div>
      </div>
<!--      <app-custom-button-->
<!--        [Show]="true"-->
<!--        [LabelText]="buttonLabel"-->
<!--        [BackButton]="true"-->
<!--        [backUrl]="'/mobile/guest'"-->
<!--        (OnClick)="takeAction()"-->
<!--        [HideMainButton]="buttonLabel  === ''"></app-custom-button>-->
    </div>
  </div>
</div>
